<template>
  <div class="anchor-container-item">
    <div class="anchor-container-item-header">
      <div class="header-label">
        {{name}}
      </div>
      <div class="head-affter" v-if="$slots['header-affter']">
        <slot name="header-affter"></slot>
      </div>
    </div>
    <div class="anchor-container-item-main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'anchor-container-item',
  props: {
    // 锚点项名字
    name: {
      type: String,
      default: ''
    },
    // 锚点向值
    value: {
      type: [String, Number],
      default: ''
    },
    // 该锚点项状态, waiting || finish
    status: {
      type: String,
      default: 'waiting',
      validator: function(val) {
        return ['waiting', 'finish'].includes(val)
      }
    }
  },
  data() {
    return {
      parentInstance: null
    }
  },
  created() {
    this.parentInstance = this.getParentInstance(this, 'anchor-container')
    this.parentInstance.createEl(this)
  },
  beforeDestroy() {
    this.parentInstance.remove(this)
  },
  watch: {
    status() {
      this.parentInstance.updateData(this)
    },
    name() {
      this.parentInstance.updateData(this)
    },
    value() {
      this.parentInstance.updateData(this)
    }
  },
  methods: {
    scroll(scrollEl) {
      if (this.elementIsVisibleInViewport(scrollEl)) {
        return this.value
      } else {
        return ''
      }
    },
    elementIsVisibleInViewport (scrollEl) {
      return (this.$el.offsetTop + this.$el.offsetHeight > (scrollEl.scrollTop + this.parentInstance.offsetTop))
    },
    getParentInstance(options, parentName) {
      let parent = options.$parent
      while (parent) {
        if (parent.$options.name === parentName) {
          break
        }
        parent = parent.$parent
      }
      return parent
    }
  }
}
</script>

<style scoped lang="scss">
$active-color: #1F6EEF;
.anchor-container-item {
  width: 100%;
  .anchor-container-item-header {
    display: flex;
    margin: 16px 0;
    .header-label {
      font-weight: 500;
      color: #333;
      font-size: 14px;
      position: relative;
      display: flex;
      align-items: center;
      padding-left: 10px;
      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 4px;
        height: 14px;
        background-color: $active-color;
        margin-left: -10px;
      }
    }
    .head-affter {
      flex: 1;
      margin-left: 10px;
    }
  }
  .anchor-container-item-main {
    // margin: 15px 0;
  }
  &:last-child {
    // margin-bottom: 50px;
  }
}
</style>